<template>
  <a :href="href">点击微信登陆</a>
</template>

<script>
import config from '@/config';
import Cookies from 'js-cookie';

export default {
    data() {
        return {
            href: null,
        };
    },
    mounted() {
        const { redirect } = this.$route.query;
        if (redirect) {
            Cookies.set('wechat_redirect', redirect, { expires: 1 });
        }

        const { appid } = config.wechat;
        const redirectUri = encodeURIComponent(`${location.protocol}//${location.host}/wechat/callback`);
        const scope = 'snsapi_base';

        this.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=#wechat_redirect`;

        window.location.href = this.href;
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/wechat/Authorize.vue